export const algoliaPartnerAdapter = ({
  photo,
  title,
  metaDescription,
  slug,
  level,
  publishedAt
}) => {
  return {
    logo: photo ? { alt: title, media: { url: photo } } : null,
    title,
    description: metaDescription || null,
    link: {
      href: `/partners/${slug}`,
    },
    level: level || null,
    publishedAt
  }
}

export const algoliaPartnersAdapter = (partners) => {
  return partners.map((partner) => algoliaPartnerAdapter(partner))
}
